import { QUERY_KEYS } from 'api/query-keys';
import { sharedWorkforceService } from 'api/services';
import { useInfiniteQuery } from 'react-query';

export const useGetWorkforce = () => {
  return useInfiniteQuery({
    queryKey: QUERY_KEYS.workforce(),
    queryFn: async ({ pageParam = 0 }) => await sharedWorkforceService.getEmployees({ pageParam }),
    getNextPageParam: (lastGroup) => lastGroup.nextPage,
  });
};
